import React from 'react';

import { themeColors } from 'themes/clients/baseTheme';

import { getGoalStatusColorObject } from 'constants/ProjectConstants';
import { GOAL_PROGRESSES_FULL_LABEL } from 'constants/ProjectConstants';

import { ProgressBar } from 'uiToolkitV1/ProgressBar';

/* TODO: move below map to different file */
export const COLOR_MAP = {
  ON_TRACK: { barColor: '#B1E39F', textColor: themeColors.functional['2F8133'] },
  OFF_TRACK: { barColor: '#FCC88B', textColor: themeColors.functional.B96400 },
  AT_RISK: { barColor: '#FD9B9B', textColor: themeColors.functional.C62C02 },
  CLOSED: { barColor: '#666666', textColor: themeColors.common.white },
};

const RabbitGoalProgressBar = ({ goalProgressLevel, percentageValue, goalClosureStatus }) => {
  const label = goalClosureStatus
    ? GOAL_PROGRESSES_FULL_LABEL[`${goalProgressLevel}_${goalClosureStatus}`]
    : GOAL_PROGRESSES_FULL_LABEL[goalProgressLevel];

  const progressColors = getGoalStatusColorObject(goalProgressLevel, goalClosureStatus);

  return (
    <ProgressBar
      size="large"
      color={progressColors?.tagColor}
      text={label}
      textColor={progressColors?.textColor}
      value={percentageValue}
      showPercentage
      percentageMinWidth="5ch"
    />
  );
};
export default RabbitGoalProgressBar;
